import { radius } from '@alison/ui';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import type { ReactNode } from 'react';
import type { AdProvider, ConnectionState } from '../../lib/adNetwork.hooks.js';

const STATE_SX: Record<ConnectionState, { label: string; bgcolor: string; color: string }> = {
  not_connected: { label: 'Not connected', bgcolor: 'background.muted', color: 'text.secondary' },
  cred_ready: { label: 'Authorized', bgcolor: 'info.bg', color: 'info.main' },
  pending: { label: 'Syncing', bgcolor: 'warning.bg', color: 'warning.main' },
  connected: { label: 'Connected', bgcolor: 'success.bg', color: 'success.main' },
  needs_reauth: { label: 'Needs attention', bgcolor: 'warning.bg', color: 'warning.dark' },
};

interface StatusChipProps {
  state: ConnectionState;
  provider: AdProvider;
}

export function StatusChip({ state, provider }: StatusChipProps): ReactNode {
  const { label, bgcolor, color } = STATE_SX[state];
  return (
    <Chip
      size="small"
      icon={<Box component="span" />}
      label={label}
      data-testid={`provider-status-${provider}`}
      sx={{
        height: 22,
        borderRadius: `${radius.md}px`,
        px: 2,
        bgcolor,
        color,
        fontSize: 11,
        fontWeight: 700,
        '& .MuiChip-label': { p: 0 },
        '& .MuiChip-icon': {
          width: 6,
          height: 6,
          ml: 0,
          mr: 1,
          borderRadius: '50%',
          bgcolor: 'currentColor',
          color: 'inherit',
        },
      }}
    />
  );
}
